import moment from 'moment'

export const isDate24HoursOld = (date: string) => {
    const hours = moment().diff(moment(date), 'hours', false);

    return hours > 24;
}